import router from 'vue-router';

import rootRouting from './root.routing';

// 路由重复点击当前路由时忽略报错
const vueRouterPush = router.prototype.push;
router.prototype.push = function push(to: any) {
    return (vueRouterPush.call(this, to) as any).catch((err: any) => err);
};

export { rootRouting };
